/*
esempi di LavoratoriFilter:

    {"glossary":["*","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
        "open":false,
        "iniziale":"*",
        "selectAll":false,
        "inForza":true,
        "hired":false,
        "fired":false,
        "showAllHired":false,
        "force_periodo":"p",
        "hired_periodo":"cy",
        "fired_periodo":"cy",
        "customHired":{"startDate":"2021-12-31T23:00:00.000Z","endDate":"2022-12-31T22:59:59.999Z"},
        "customFired":{"startDate":"2021-12-31T23:00:00.000Z","endDate":"2022-12-31T22:59:59.999Z"},
        "customForce":{"startDate":"2022-10-31T23:00:00.000Z","endDate":"2022-11-30T22:59:59.999Z"},
        "qualifiche":{"selectAll":true}}

    {"glossary":["*","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
        "open":false,
        "iniziale":"*",
        "selectAll":true,
        "inForza":false,
        "hired":false,
        "fired":false,
        "showAllHired":false,
        "force_periodo":"p",
        "hired_periodo":"cy",
        "fired_periodo":"cy",
        "customHired":{"startDate":"2021-12-31T23:00:00.000Z","endDate":"2022-12-31T22:59:59.999Z"},
        "customFired":{"startDate":"2021-12-31T23:00:00.000Z","endDate":"2022-12-31T22:59:59.999Z"},
        "customForce":{"startDate":"2022-10-31T23:00:00.000Z","endDate":"2022-11-30T22:59:59.999Z"},
        "qualifiche":{"selectAll":false,"IM":true,"IN":true}}
*/

import {LavoratoreFilterSelection} from "@commons/features/lavoratore/lavoratore.api";
import moment from "moment/moment";
import {LavoratoriFilter} from "@commons/filters";
import {CDate} from "@commons/types";

type FPNetInterval = { startDate: any, endDate: any }

export function HR2FPNetFilter(filter: LavoratoreFilterSelection, FPNet2Filter: LavoratoriFilter) {
    const getInterval = (dataDa: CDate, dataA: CDate) => {
        if (dataDa && dataA) {
            return {
                startDate: moment(dataDa, 'YYYYMMDD').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                endDate: moment(dataA, 'YYYYMMDD').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            }
        } else
            return {
                startDate: null,
                endDate: null,
            };
    }

    let qualifiche: any = {selectAll: true}
    if (filter.qualifiche && filter.qualifiche.length > 0) {
        qualifiche.selectAll = false;
        for (let item of filter.qualifiche) {
            qualifiche[item] = true;
        }
    }
    return {
        iniziale: filter.iniziale,
        selectAll: filter.tutti === 'all',
        inForza: filter.inForzaSection,
        hired: filter.hiredSection,
        fired: filter.firedSection,
        force_periodo: filter.inForza,
        hired_periodo: filter.hired,
        fired_periodo: filter.fired,
        customHired: getInterval(filter.hiredDataDa, filter.hiredDataA),
        customFired: getInterval(filter.firedDataDa, filter.firedDataA),
        customForce: getInterval(filter.forceDataDa, filter.forceDataA),
        qualifiche: qualifiche,
    } as LavoratoriFilter;
    //showAllHired: boolean;
}

export function FPNet2HRFilter(filter: LavoratoriFilter, FPNet2Filter: Partial<LavoratoreFilterSelection>) {
    const convertDate = (interval: FPNetInterval | undefined, prop: keyof FPNetInterval) => {
        if (interval) {
            try {
                let date = interval[prop] ? moment(interval[prop]).format('YYYYMMDD') : null;
                return date !== 'Invalid date' ? date : null
            } catch (err) {
                return null;
            }
        }
        return null;
    }
    let qualifiche: string[] = [];
    if (filter.qualifiche && !filter.qualifiche.selectAll) {
        let k: keyof typeof filter.qualifiche;
        for (k in filter.qualifiche) {
            if (filter.qualifiche[k]) {
                qualifiche.push(k);
            }
        }
    }
    return {
        ...FPNet2Filter,
        iniziale: filter.iniziale,
        tutti: filter.selectAll ? 'all' : null,
        inForzaSection: filter.inForza,
        hiredSection: filter.hired,
        firedSection: filter.fired,
        inForza: filter.force_periodo,
        hired: filter.hired_periodo,
        fired: filter.fired_periodo,
        hiredDataDa: convertDate(filter.customHired, 'startDate'),
        hiredDataA: convertDate(filter.customHired, 'endDate'),
        firedDataDa: convertDate(filter.customFired, 'startDate'),
        firedDataA: convertDate(filter.customFired, 'endDate'),
        forceDataDa: convertDate(filter.customForce, 'startDate'),
        forceDataA: convertDate(filter.customForce, 'endDate'),
        qualifiche: qualifiche
    } as Partial<LavoratoreFilterSelection>;
    //showAllHired: boolean;
}
